import CustomerOnboardingHttp from 'pages/customer-onboarding/services/customer.service';
import React, { useEffect, useState } from 'react';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import infoIco from 'assets/images/i-circle.svg';
import successIco from 'assets/images/check.png';
import { toast } from 'react-toastify';
import Toast from 'shared/common/toast';
import OtpModal from 'shared/common/modal/otp_modal';
import ChangePassword from './change-password';
import DocumentUpload from './document-upload';
import UserHttp from '../services/profile.service';
import PanCardUpload from './pan-card-upload';

interface PropsType {
  user: any;
  customer: any;
}

const UserInfo: React.FC<PropsType> = ({ user, customer }) => {
  const [panNumber, setPanNumber] = useState<any>('');
  const [aadhaarNumber, setAadhaarNumber] = useState<any>('');

  const [isPanVerify, setPanVerify] = useState(true);
  const [isPanVerifing, setPanVerifing] = useState(false);
  const [isPanVerifySuccess, setPanVerifySuccess] = useState(false);
  const [isPanVerifyFeild, setPanVerifyFeild] = useState(false);

  const [isAadhaarVerify, setAadhaarVerify] = useState(true);
  const [isAadhaarVerifing, setAadhaarVerifing] = useState(false);
  const [isAadhaarVerifySuccess, setAadhaarVerifySuccess] = useState(false);
  const [isAadhaarVerifyFeild, setAadhaarVerifyFeild] = useState(false);

  const [modalShow, setModalShow] = React.useState(false);
  const [otp, setOtp] = useState<any>();
  const [resend, setResend] = useState(false);

  const [isShow, setIsShow] = useState(false);
  const [isShowUpload, setIsShowUpload] = useState(false);

  const [isDocShow, setDocShow] = useState(false);

  const [docs, setDocs] = useState<any>([]);

  const [txtSuscces, setTxtSuscces] = useState('');
  const [txtError, setTxtError] = useState('');

  const [EmailDisable, setEmailDisable] = useState(true);

  useEffect((): any => {
    if (user?.kyc?.aadhaar?.data?.maskedAadhaarNumber) {
      if (user?.kyc?.aadhaar?.isVerified) verifyAadhaarSuccess();
      setAadhaarNumber(user.kyc.aadhaar.data.maskedAadhaarNumber);
    }
  }, [user]);

  useEffect((): any => {
    if (customer?.kyc?.pan?.value) {
      setPanNumber(customer.kyc.pan.value);
      verifySuccess();
    }
  }, [customer]);

  const toVerify = () => {
    setPanVerify(true);
    setPanVerifing(false);
    setPanVerifySuccess(false);
    setPanVerifyFeild(false);
  };

  const verifyInprograss = () => {
    setPanVerify(false);
    setPanVerifing(true);
    setPanVerifySuccess(false);
    setPanVerifyFeild(false);
  };

  const verifySuccess = () => {
    setPanVerify(false);
    setPanVerifing(false);
    setPanVerifySuccess(true);
    setPanVerifyFeild(false);
  };

  const verifyFeild = () => {
    setPanVerify(false);
    setPanVerifing(false);
    setPanVerifySuccess(false);
    setPanVerifyFeild(true);
  };

  const toAadhaarVerify = () => {
    setAadhaarVerify(true);
    setAadhaarVerifing(false);
    setAadhaarVerifySuccess(false);
    setAadhaarVerifyFeild(false);
  };

  const verifyAadhaarInprograss = () => {
    setAadhaarVerify(false);
    setAadhaarVerifing(true);
    setAadhaarVerifySuccess(false);
    setAadhaarVerifyFeild(false);
  };

  const verifyAadhaarSuccess = () => {
    setAadhaarVerify(false);
    setAadhaarVerifing(false);
    setAadhaarVerifySuccess(true);
    setAadhaarVerifyFeild(false);
  };

  const verifyAadhaarFeild = () => {
    setAadhaarVerify(false);
    setAadhaarVerifing(false);
    setAadhaarVerifySuccess(false);
    setAadhaarVerifyFeild(true);
  };

  const panVerify = async () => {
    if (isPanVerifySuccess) return;
    verifyInprograss();
    try {
      const res: any = await CustomerOnboardingHttp.verifyPanNumber({
        pan: panNumber,
      });
      if (res && res.status === 200) {
        //setPanNumber(res.data.data.kycId);
        verifySuccess();
      } else {
        verifyFeild();
        //toast.error(res.data.errors[0].title);
      }
      // setLoading(false);
    } catch (err: any) {
      verifyFeild();
      console.log(err);
      // toast.error(err.data.errors[0].title);
    }
  };

  const aadhaarVerify = async () => {
    if (isAadhaarVerifySuccess) return;

    verifyAadhaarInprograss();

    if (!aadhaarNumber) {
      verifyAadhaarFeild();
      return;
    }
    try {
      //setAadhaarNumber(values.aadhaar_number);
      const res: any = await CustomerOnboardingHttp.sendAadhaarOtp(
        {
          name: user.displayName,
          aadhaarNo: aadhaarNumber,
          consent: true,
          user_id:user?.userId

        },
        user?.userId
      );
    
      if (res && res.status === 200) {
        setModalShow(true);
        setTxtSuscces('OTP has been sent.');
        setTxtError('');
      } else {
        setTxtError(res.data.errors[0].title);
        toast.error(res.data.errors[0].title);
      }
    } catch (err: any) {
      // setUsernameError(err.message);
      console.log(err);
      toast.error(err.data.errors[0].title);
      verifyAadhaarFeild();
      //setError(err);
    }
  };

  const onAadhaarSuccess = async (otp) => {
    setOtp(otp);

    try {
      const data = {
        otp: otp,
        aadhaarNo: aadhaarNumber,
      };
      const res: any = await CustomerOnboardingHttp.verifyAadhaarOtp(
        data,
        user?.userId
      );
      if (res.status === 200 && res.data.data) {
        setModalShow(false);
        verifyAadhaarSuccess();
        //createIndCustomer();
      } else {
        toAadhaarVerify();
      }
    } catch (e: any) {
      toast.error(e.data.errors[0].title);
      verifyAadhaarFeild();
      console.log(e);
    }
  };

  const resendOtp = () => {
    aadhaarVerify();
    setResend(false);
  };

  const changePassword = () => {
    onHandleSideModal(true);
  };

  const onHandleSideModal = (value) => {
    setIsShow(value);
  };

  const onHandleUploadSideModal = (value) => {
    setIsShowUpload(value);
  };

  const onHandleDocSideModal = (value) => {
    setDocShow(value);
  };

  const getDocs = async () => {
    setDocShow(true);
  };

  const onEmailEdit = () => {
    setEmailDisable(!EmailDisable);
  };
  return (
    <>
      {/*<Toast/>*/}
      <ChangePassword handleModal={onHandleSideModal} isShow={isShow} />

      <DocumentUpload
        handleModal={onHandleDocSideModal}
        isShow={isDocShow}
        customerId={customer.customerId}
      />
      <PanCardUpload
        handleModal={onHandleUploadSideModal}
        isShow={isShowUpload}
        customerId={customer.customerId}
      />
      <Card>
        <Card.Body className='p-5 pb-0'>
          <div>
            <Card.Title>Personal Information</Card.Title>
            <Row>
              <Col md={6}>
                <Form.Group className='mb-3' controlId='name'>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    disabled={true}
                    type='text'
                    value={user?.displayName || ''}
                  />
                </Form.Group>
              </Col>
              {/* <Col md={6}>
                <Form.Group className='mb-3' controlId='email'>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    disabled={true}
                    type='email'
                    value={user?.email?.value || ''}
                  />
                </Form.Group>
              </Col> */}

              <Col md={6}>
                <Form.Group className='mb-3' controlId='password'>
                  <Form.Label>Email</Form.Label>
                  <div className='input-group mb-3'>
                    <Form.Control
                      disabled={EmailDisable}
                      type='text'
                      value={user?.email?.value || ''}
                    />
                    <div className='input-group-text'>
                      {/* <button
                        className='btn'
                        onClick={onEmailEdit}
                        type='button'
                        id='button-addon2'
                      >
                        {EmailDisable?'Edit':"Save"}
                      </button> */}
                    </div>
                  </div>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className='mb-3' controlId='mobile'>
                  <Form.Label>Mobile</Form.Label>
                  <Form.Control
                    disabled={true}
                    type='text'
                    value={user?.mobile?.value || ''}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3' controlId='password'>
                  <Form.Label>Password</Form.Label>
                  <div className='input-group mb-3'>
                    <Form.Control
                      disabled={true}
                      type='password'
                      value='......'
                    />
                    <div className='input-group-text'>
                      <button
                        className='btn'
                        onClick={changePassword}
                        type='button'
                        id='button-addon2'
                      >
                        Change
                      </button>
                    </div>
                  </div>
                </Form.Group>
              </Col>
            </Row>
          </div>
        </Card.Body>
        <div className='mb-3'></div>
      </Card>
      <OtpModal
        show={modalShow}
        handleClose={() => setModalShow(false)}
        title={'Enter the OTP sent your Aadhar registered Mobile Number'}
        onSuccess={(otp) => onAadhaarSuccess(otp)}
        resend={resendOtp}
        txtSuscces={txtSuscces}
        txtError={txtError}
      />
    </>
  );
};

export default UserInfo;
